var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAk135430(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 87.7 30",
    style: {
      enableBackground: "new 0 0 87.7 30"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: -6.7,
    transform: "matrix(0.4697 -0.8828 0.8828 0.4697 0.5319 16.023)",
    width: 1.2,
    height: 28.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: -0.4,
    y: 20.8,
    transform: "matrix(0.8676 -0.4973 0.4973 0.8676 -8.7854 9.6978)",
    width: 28.5,
    height: 1.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25.7,
    y: 11,
    width: 3.6,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 58,
    y: 11,
    width: 3.6,
    height: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.2,30H0V0h30.2V30z M1.2,28.8H29V1.2H1.2V28.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.8,25.9H4V3.7h22.8V25.9z M5.1,24.8h20.5v-20H5.1V24.8z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59.8,
    y: 7,
    transform: "matrix(0.8832 -0.469 0.469 0.8832 5.1028 35.6288)",
    width: 28.5,
    height: 1.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 73.3,
    y: 7.1,
    transform: "matrix(0.4972 -0.8676 0.8676 0.4972 18.6252 74.8302)",
    width: 1.2,
    height: 28.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.7,30H57.5V0h30.2V30z M58.7,28.8h27.9V1.2H58.7V28.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.7,25.9H60.9V3.7h22.8V25.9z M62.1,24.8h20.5v-20H62.1V24.8z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 31.1,
    y: 7,
    transform: "matrix(0.8828 -0.4697 0.4697 0.8828 1.7575 22.1821)",
    width: 28.5,
    height: 1.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 44.6,
    y: 7.1,
    transform: "matrix(0.497 -0.8677 0.8677 0.497 4.1759 49.8953)",
    width: 1.2,
    height: 28.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.9,30H28.7V0h30.2V30z M29.9,28.8h27.9V1.2H29.9V28.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55,25.9H32.2V3.7H55V25.9z M33.3,24.8h20.5v-20H33.3V24.8z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAk135430);
export default __webpack_public_path__ + "static/media/AK1_3_543_0.9e31ea87721c42ab530715f43ea0155f.svg";
export { ForwardRef as ReactComponent };